import { useTranslation } from 'react-i18next';

import ContentBlock from '@/components/molecules/ContentBlock';
import LiceStatus from '@/components/molecules/LiceStatus';
import SomethingHappened from '@/components/SomethingHappened';

import type { CageDashboardViewProps } from '../types';

import ViewButton from './ViewButton';

interface LiceCardProps {
    lice: CageDashboardViewProps['lice'];
    liceUrl: string;
}

/** The three-day lice averages, with a way through to the lice module when licensed. */
export default function LiceCard(props: LiceCardProps) {
    const { lice, liceUrl } = props;
    const { t } = useTranslation();

    return (
        <ContentBlock
            title={t('common.labels.lice')}
            spacing="none"
            headerActions={lice.hasLicense && <ViewButton to={liceUrl} />}>
            {lice.loadError ? (
                <SomethingHappened {...lice.loadError} />
            ) : (
                <LiceStatus
                    liceInMin200Fish={lice.snapshot}
                    licePageUrl={liceUrl}
                    hasLiceLicense={lice.hasLicense}
                    isChileanLice={lice.isChilean}
                    isLoading={lice.isLoading}
                />
            )}
        </ContentBlock>
    );
}
